module.exports = __webpack_public_path__ + "img/substitution-in.b401e1df.svg";